import {Dispatch, SetStateAction} from 'react';
import {BottomSheet} from 'react-spring-bottom-sheet';
import Button from '../../../../../components/button';

interface IProps {
  setShouldOpen: Dispatch<SetStateAction<boolean>>;
  open: boolean;
}

const UploadInfoBottomSheet = ({setShouldOpen, open}: IProps) => {
  return (
    <BottomSheet
      onDismiss={() => setShouldOpen(false)}
      open={open}
      blocking={true}
      snapPoints={({minHeight, maxHeight}) => [minHeight, maxHeight / 0.6]}
    >
      <div className="relative flex flex-col w-full gap-2 px-6 pt-2 pb-8 CalenderWrapperBottomSheet-wrapper">
        <i
          className="absolute text-2xl text-gray-500 icon-nameClose-remove top-4 left-4"
          onClick={() => setShouldOpen(false)}
        />

        <p className="flex justify-center w-full p-0 m-0 mt-2 text-lg font-medium text-zinc-700">
          پیش پرداخت و تاییدیه شغل کشاورزی{' '}
        </p>

        <div className="flex flex-col justify-between w-full gap-3">
          <div className="w-full px-0 py-4 m-0 text-sm text-right text-gray-800 font-Regular">
            هر مدرکی از نهادهای دولتی که نشان از شغل کشاورزی دارد را به همراه
            تصویر پیش پرداخت خرید خود بارگذاری کنید.
          </div>

          <div className="flex items-center gap-2">
            <Button
              className="w-full"
              onClick={() => {
                setShouldOpen(false);
              }}
            >
              متوجه شدم
            </Button>
          </div>
        </div>
      </div>
    </BottomSheet>
  );
};

export default UploadInfoBottomSheet;
